export default __webpack_public_path__ + "static/accuracy-74889dad0a1babba5e9fbe65f95c931d.png";